import {
  IconAlertOctagonFilled,
  IconAlertTriangleFilled,
  IconInfoSquareRoundedFilled
} from "@tabler/icons-react";

import { Collapse } from "antd";
import DeletedIcon from "components/svg-icons/deleted-icon";
import ScheduleImpactV3 from "./schedule-impact-v3";
import { EntityType } from "../../../../constants/index";

function RenderImpactCategory(props: {
  categoryType: any;
  count: any;
  showCategory?: boolean;
  data: any;
  entityType: EntityType;
}) {
  const { categoryType, count, showCategory = true, data, entityType } = props;

  const getHeader = (catType: any) => {
    const itemCount = count || 0;
    return (
      <div>
        {(() => {
          switch (catType) {
            case "deleted":
              return (
                <div data-testid="deleted-header">
                  <DeletedIcon
                    className="mb-[-4px] mr-2"
                    data-testid="deleted-icon"
                  />
                  <span data-testid="deleted-text">
                    Activities Deleted ({itemCount})
                  </span>
                </div>
              );
            case "high":
              return (
                <div data-testid="high-header">
                  <IconAlertOctagonFilled
                    size={18}
                    className="mb-[-4px] mr-2 text-red-500"
                    data-testid="high-impact-icon"
                  />
                  <span data-testid="high-impact-text">
                    Attention required ({itemCount})
                  </span>
                </div>
              );
            case "medium":
              return (
                <div data-testid="medium-header">
                  <IconAlertTriangleFilled
                    size={18}
                    className="mb-[-4px] mr-2 text-yellow-500"
                    data-testid="medium-impact-icon"
                  />
                  <span data-testid="medium-impact-text">
                    Review recommended ({itemCount})
                  </span>
                </div>
              );
            case "low":
              return (
                <div data-testid="low-header">
                  <IconInfoSquareRoundedFilled
                    size={18}
                    className="mb-[-4px] mr-2 text-slate-500"
                    data-testid="low-impact-icon"
                  />
                  <span data-testid="low-impact-text">
                    Information only ({itemCount})
                  </span>
                </div>
              );
            default:
              return <div data-testid="default-header">default</div>;
          }
        })()}
      </div>
    );
  };

  const renderImpacts = (activity: any, entityTyp: EntityType) => {
    // console.log("activity =>", activity);
    return (
      <ScheduleImpactV3
        key={activity.id}
        activity={activity}
        entityType={entityTyp}
      />
    );
  };

  if (!categoryType) {
    return null;
  }

  if (entityType === EntityType.None) {
    console.error("Entity type is not define =>", entityType);
    return null;
  }

  return (
    <div data-testid="impact-category-container">
      {count > 0 && showCategory && (
        <Collapse
          accordion
          key="attentionRequired-a"
          data-testid={`${categoryType}-impact-collapse`}
        >
          <Collapse.Panel
            key="attentionRequired-material"
            header={getHeader(categoryType)}
            className="impactBoxContainerTitle"
            data-testid={`${categoryType}-impact-panel`}
          >
            {count
              ? data.map((activity: any) => renderImpacts(activity, entityType))
              : null}
          </Collapse.Panel>
        </Collapse>
      )}{" "}
    </div>
  );
}

export default RenderImpactCategory;
